module.exports = __webpack_public_path__ + "media/stylesheets/opensans800-1dd4bdcae59c528d20852b2285100e63.woff2";